<app-in-app-page>
  <app-header title="Settings"></app-header>

  <div class="settings">
    <nav class="settings-nav-tabs">
      <a
        *ngFor="let tab of tabs"
        [routerLink]="tab.routerLink"
        class="settings-nav-tab"
        [class.settings-nav-tab_active]="isCurrentUrlEquals(tab.routerLink)"
      >
        {{ tab.label }}
      </a>
    </nav>

    <router-outlet></router-outlet>
  </div>
</app-in-app-page>
